import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ArrowLeftIcon, CopyIcon, CheckIcon } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
export function ThankYouReferralPage() {
  const {
    t,
    getPath,
    navigate
  } = useLanguage();
  const [copied, setCopied] = useState(false);
  const [referralLink, setReferralLink] = useState('');
  return <div className="min-h-screen w-full flex flex-col" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-767" data-mp="2tpip4fnhmbu5">
      <Navigation data-id="element-768" data-mp="2fp7wp86j4p6v" />

      <section className="flex-1 flex items-center justify-center px-4 py-32" data-id="element-769" data-mp="2frtzkuih6gir">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-lg" data-id="element-770" data-mp="2jp9p0qqdk69h">
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} className="w-24 h-24 mx-auto mb-8 rounded-full flex items-center justify-center" style={{
          backgroundColor: 'var(--accent)'
        }} data-id="element-771" data-mp="nyy6sgvgm6du">
            <UsersIcon className="w-12 h-12 text-white" data-id="element-772" data-mp="11yzb66axnvy2" />
          </motion.div>

          <h1 className="text-3xl sm:text-4xl font-bold mb-4" style={{
          color: 'var(--text-primary)'
        }} data-id="element-773" data-mp="1gmu33kh49wa3">
            Welcome to the Program!
          </h1>

          <p className="text-lg mb-4" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-774" data-mp="1pn0ff312wq7o">
            Your referral application has been received.
          </p>

          <p className="text-base mb-8" style={{
          color: 'var(--text-muted)'
        }} data-id="element-775" data-mp="ickgi0c27z5e">
            We'll contact you within 24 hours with your unique referral link and
            all the details you need to start earning €100 per referral.
          </p>

          <div className="rounded-2xl border p-6 mb-8 text-left" style={{
          borderColor: 'var(--border)',
          backgroundColor: 'var(--bg-secondary)'
        }} data-id="element-776" data-mp="w48s82iecllu">
            <h3 className="font-semibold mb-3" style={{
            color: 'var(--text-primary)'
          }} data-id="element-777" data-mp="162y8jqun9xzz">
              What happens next?
            </h3>
            <ul className="space-y-2 text-sm" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-778" data-mp="3crb8zwvu5q8w">
              <li className="flex items-start gap-2" data-id="element-779" data-mp="3gtexbm3lspbl">
                <span style={{
                color: 'var(--accent)'
              }} data-id="element-780" data-mp="399xbg22vznbv">
                  1.
                </span>
                We'll review your application
              </li>
              <li className="flex items-start gap-2" data-id="element-781" data-mp="2zk3zv12qv87m">
                <span style={{
                color: 'var(--accent)'
              }} data-id="element-782" data-mp="2vi90w38ad6x0">
                  2.
                </span>
                You'll receive your unique referral link
              </li>
              <li className="flex items-start gap-2" data-id="element-783" data-mp="3n9onvydr8vnr">
                <span style={{
                color: 'var(--accent)'
              }} data-id="element-784" data-mp="3j71ye44k3mtq">
                  3.
                </span>
                Share the link and earn €100 for each successful referral
              </li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-785" data-mp="22ssatc85223y">
            <a href={getPath('')} onClick={e => {
            e.preventDefault();
            navigate('');
          }} className="inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm font-semibold transition-all hover:scale-105" style={{
            backgroundColor: 'var(--bg-secondary)',
            color: 'var(--text-primary)',
            border: '1px solid var(--border)'
          }} data-id="element-786" data-mp="3qpzumdco3fyj">
              <ArrowLeftIcon className="w-4 h-4" data-id="element-787" data-mp="ia7qfrzfp2ax" />
              {t('nav.home')}
            </a>
          </div>
        </motion.div>
      </section>

      <Footer data-id="element-788" data-mp="49n7mvtir6hf" />
    </div>;
}